namespace GeniuzPOS.AdvPromo {
    export interface Adv05ItemDetailRow {
        Id?: string;
        StartPromoDate?: string;
        EndPromoDate?: string;
        PmId?: string;
        PmGroupId?: string;
        PmType?: number;
        PPtype?: number;
        PmTypeDesc?: string;
        SkuCode?: string;
        PluCode?: string;
        PluShortDesc?: string;
        ItemType?: number;
        AssortFg?: number;
        StyleId?: string;
        StyleName?: string;
        CatCode?: string;
        CatName?: string;
        SubCat1Code?: string;
        SubCat1Name?: string;
        SubCat2Code?: string;
        SubCat2Name?: string;
        BrandCode?: string;
        BrandName?: string;
        SupplCode?: string;
        SupplName?: string;
        Normalprice?: number;
        Remark?: string;
        PromotionPrice?: string;
        DiscPc?: string;
    }

    export namespace Adv05ItemDetailRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PmId';
        export const localTextPrefix = 'AdvPromo.Adv05ItemDetail';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '4ADVANCED_PROMOTION:รายงาน:รายการสินค้าร่วมโปร:View';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            StartPromoDate = "StartPromoDate",
            EndPromoDate = "EndPromoDate",
            PmId = "PmId",
            PmGroupId = "PmGroupId",
            PmType = "PmType",
            PPtype = "PPtype",
            PmTypeDesc = "PmTypeDesc",
            SkuCode = "SkuCode",
            PluCode = "PluCode",
            PluShortDesc = "PluShortDesc",
            ItemType = "ItemType",
            AssortFg = "AssortFg",
            StyleId = "StyleId",
            StyleName = "StyleName",
            CatCode = "CatCode",
            CatName = "CatName",
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name",
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            SupplCode = "SupplCode",
            SupplName = "SupplName",
            Normalprice = "Normalprice",
            Remark = "Remark",
            PromotionPrice = "PromotionPrice",
            DiscPc = "DiscPc"
        }
    }
}
